<template>
    <b-button @click="$emit('click')" :variant="$attrs.variant" :disabled="$attrs.disabled"  :size="$attrs.size">
        <slot v-if="!isProcessing" name="default"> </slot>
        <span v-else>
            <i :class="['fa', selectedIcon, 'fa-spin']"></i> {{ busyLabel }}
        </span>
    </b-button>
</template>

<script>
export default {
    name: 'LockButton',
    props: {
        isProcessing: {
            type: Boolean,
            default: false,
        },
        selectedIcon: {
            type: String,
            default: 'fa-circle-o-notch', // fa-spinner, fa-cog, fa-refresh, fa-circle-o-notch
        },
        busyLabel: {
            type: String,
            default: 'Procesando...',
        }
    },
};
</script>